module.exports = __webpack_public_path__ + "img/Call.ae7e776a.svg";